export function AcceptIcon() {
	return (
		<svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d={`M5.81362 9.88085L15.131 0.820713C15.3509 0.606904 15.6074 0.5 15.9006 0.5C16.1938 0.5 16.4503 
                    0.606904 16.6702 0.820713C16.8901 1.03452 17 1.28842 17 1.58241C17 1.87639 16.8901 2.13029 
                    16.6702 2.3441L6.5832 12.1793C6.36332 12.3931 6.10679 12.5 5.81362 12.5C5.52045 12.5 5.26392 
                    12.3931 5.04404 12.1793L0.316627 7.58241C0.0967471 7.3686 -0.00861196 7.1147 0.000549699 
                    6.82071C0.00971135 6.52673 0.124232 6.27283 0.344112 6.05902C0.563991 5.84521 0.825099 5.73831 
                    1.12743 5.73831C1.42977 5.73831 1.69087 5.84521 1.91075 6.05902L5.81362 9.88085Z`}
				fill="#009245"
			/>
		</svg>
	);
}
